export default __webpack_public_path__ + "static/media/avatar5.8dc945af.png";